import React from 'react';

interface ISvgIcon {
  color?: string;
}

const Share = ({color = "#FFF"} : ISvgIcon) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11.937" height="13.73" viewBox="0 0 11.937 13.73">
      <path id="play-svgrepo-com" d="M97.419,85.728a1.32,1.32,0,0,1-.653-.174,1.467,1.467,0,0,1-.726-1.281V73.453a1.465,1.465,0,0,1,.726-1.281,1.311,1.311,0,0,1,1.335.017l9.247,5.535a1.343,1.343,0,0,1,0,2.276L98.1,85.537A1.325,1.325,0,0,1,97.419,85.728Z" transform="translate(-96.04 -71.998)" fill={color} />
    </svg>
  )
}

export default Share;